import React from 'react';
import PropTypes from 'prop-types';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';
import DocumentTemplateForm from './document_template_form';

import { createStore } from 'redux';
import thunk from 'redux-thunk';
import { applyMiddleware } from 'helpers/redux_dev_tools';
import rootReducer from './store/root_reducer';
import { Provider } from 'react-redux';
import { nanoid } from 'nanoid';
import PageTemplateForm from './page_template_form';

export default function DocumentDefaults({ basePath, cancelPath, companyId, template, defaults }) {
  const { allAvailablePages } = template;
  const defaultPages = defaults.defaultPages ? defaults.defaultPages.map(page => ({
    ...page,
    key: nanoid()
  })) : null;

  const availablePageTemplateTreeIds = (defaults.availablePageTemplateTreeIds || []).map(page => ({
    ...page,
    key: nanoid()
  }));

  const formData = { ...defaults, defaultPages, availablePageTemplateTreeIds };

  const store = createStore(rootReducer, { formData, availablePages: allAvailablePages }, applyMiddleware(thunk));

  const RedirectWithQueryParams = (values) => {
    // Extract the search (query string) from props.location
    const queryParams = values.location.search;

    return <Redirect to={`/edit${queryParams}`} />;
  };

  return (
    <Provider store={store}>
      <Router basename={basePath}>
        <Switch>
          <Route exact path="/edit">
            <DocumentTemplateForm
              afterSavePath={cancelPath}
              basePath={basePath}
              companyId={companyId}
              template={template}
            />
          </Route>
          <Route path="/pages/:id" strict>
            <PageTemplateForm
              basePath={basePath}
              documentTemplateId={template.id}
              documentTemplateName={template.name}
            />
          </Route>
          <Route exact path="/" render={values => <RedirectWithQueryParams {...values} />} />
        </Switch>
      </Router>
    </Provider>
  );
}

DocumentDefaults.propTypes = {
  basePath: PropTypes.string.isRequired,
  cancelPath: PropTypes.string.isRequired,
  companyId: PropTypes.number,
  defaults: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired
};
